export default __webpack_public_path__ + "static/media/pic1.6dde42f6.jpg";